import { Reveal, Kicker } from "../lib/motion";

const CHAPTERS = [
  { n: "01", word: "Clarity", text: "Decision-ready numbers, delivered when they matter — not weeks after the month ends." },
  { n: "02", word: "Control", text: "Disciplined close, reconciliations and internal controls that stand up to auditors and investors." },
  { n: "03", word: "Visibility", text: "Real-time sight of cash, runway, margins and unit economics across every entity." },
  { n: "04", word: "Confidence", text: "Compliance handled systematically, so growth never outruns governance." },
];

export const Problem = () => (
  <section data-testid="problem-section" className="bg-mist py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid lg:grid-cols-2 gap-14 lg:gap-24">
        <div>
          <Reveal>
            <Kicker>The Problem We Solve</Kicker>
            <h2 className="mt-6 font-display text-4xl md:text-5xl font-bold tracking-tight text-navy leading-[1.1]">
              You build the business.
              <span className="block mt-2 font-editorial italic font-medium text-navy/75">
                We strengthen the finance behind it.
              </span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-8 space-y-5 text-base md:text-lg leading-relaxed text-body">
              <p>
                As businesses scale, finance becomes more complex. Reporting slows
                down. Compliance risk increases. Cash visibility becomes critical.
                Investors expect better information. Finance teams struggle with
                disconnected systems, spreadsheets and repetitive work.
              </p>
              <p>
                But many growing companies are not yet ready — or do not need — a
                full traditional CFO organisation.
              </p>
              <p className="font-semibold text-navy">
                Cogniti.ai CFO provides experienced finance leadership and
                execution at the level the business actually needs.
              </p>
            </div>
          </Reveal>
        </div>

        <div className="flex flex-col justify-center">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.1}>
              <div
                data-testid={`chapter-${c.n}`}
                className="group flex gap-6 md:gap-8 border-b border-border py-7 first:border-t transition-colors duration-300 hover:bg-white/60"
              >
                <span className="font-editorial italic text-4xl md:text-5xl text-brand/90 leading-none select-none">
                  {c.n}
                </span>
                <div>
                  <h3 className="font-display text-2xl font-bold text-navy">{c.word}</h3>
                  <p className="mt-2 text-sm md:text-base leading-relaxed text-body max-w-md">{c.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
